import { FC, useEffect, useMemo, useRef, useState } from 'react'
import { ToastContainer } from 'react-toastify'
import DataTable from 'react-data-table-component'
import { fetchData, getTranslatedValue, toasterrormsg, toastsuccessmsg } from '../../../reusable'
import { KTIcon } from '../../../_metronic/helpers'
import { PageTitle } from '../../../_metronic/layout/core'
import { Tr } from '../../../_metronic/i18n/Tr'
import { Rating } from 'react-simple-star-rating'
import { Modal } from 'react-bootstrap'
import moment from 'moment'
import Select from 'react-select'
import { useLang } from '../../../_metronic/i18n/Metronici18n'
import { useProfileStore } from '../../store/profielStore'

const ViewRatingAndReviewBookingWise: FC = () => {  
  const t = Tr()
  const lang = useLang()
  var vendorId = "";
  const vendorData = sessionStorage.getItem("vendor");
  if (vendorData) {
    var vendor = JSON.parse(vendorData);
    vendorId = vendor.vendorId;
  } else {
    console.log("No vendor data found");
  }

  const [reviewList, setReviewList] = useState([])
  const [searchTerm, setSearchTerm] = useState('')
  const [loading, setLoading] = useState('')
  const [focus, setFocus] = useState('')
  const [limit, setLimit] = useState(10)
  const [offset, setOffset] = useState(0)
  const [totalRecords, setTotalRecords] = useState('') as any
  const [sortColumn, setSortColumn] = useState('')
  const [sortDirection, setSortDirection] = useState<'asc' | 'desc'>('desc')
  var categoryId: any = sessionStorage.getItem("categoryId");

  // show rating info  modal 
  const [showRatingInfo, setShowRatingInfo] = useState(false)
  const handleCloseRatingInfo = () => setShowRatingInfo(false)
  const handleShowRatingInfo = () => setShowRatingInfo(true)

  // show report modal

  const [reviewDetail, setReviewDetail] = useState({}) as any
  const [url, setUrl] = useState('')
  const [apiTerm, setApiTerm] = useState('')

  // report reason related states
  const [showReportInfo, setShowReportInfo] = useState(false)

  const handleCloseReportInfo = () => {
    setShowReportInfo(false)
    setReportReasonId("")
    setSelectedRatingId("")
    setDescription("")
    setReviewIsAlreadySend(false)
  }
  const handleShowReportInfo = () => setShowReportInfo(true)
  const [reportReasonList, setReportReasonList] = useState([])
  const [selectedRatingId, setSelectedRatingId] = useState("")
  const [reportReasonId, setReportReasonId] = useState("")
  const [description, setDescription] = useState("")
  const [reviewIsAlreadySend, setReviewIsAlreadySend] = useState(false)

  // set error state
  const [error, setError] = useState([{
    reportReasonId: '',
    description: '',
  }])

  // remove validation function
  const removeError = (err: any) => {
    var tmp = [...error] as any;
    tmp[0][err] = "";
    setError(tmp);
  }
  const categoryWiseReviewListApiCall = async () => {
    var tmp: any = sessionStorage.getItem("vendor")
    tmp = JSON.parse(tmp)

    var param: any = {
      vendorId: vendorId,
      limit: limit,
      offset: offset,
      search: apiTerm,
      categoryId: categoryId,
    }

    var res = await fetchData('public/reviewCategoryWisePropertyTypeBooking ', param)

    if (res.status == '200') {
      setUrl(res.url)
      var data = res.data
      setTotalRecords(data.totalRecords)
      setReviewList(data.data)
    } else {
      toasterrormsg(res.message)
    }
  }

  // report reason api call
  const reportListApiCall = async () => {

    var res = await fetchData('public/viewreportreason ', {})

    if (res.status == '200') {
      var data = res.data

      let opt: any = []
      data.map((item: any) => {
        opt.push({ value: item.reportreasonId, label: getTranslatedValue(lang, item, '_reason') })
      })
      setReportReasonList(opt)

    } else {
      toasterrormsg(res.message)
    }
  }


  //report details api call 
  const reportDetailApiCall = async (ratingId: any) => {
    const param = {
      ratingId: ratingId
    }

    var res = await fetchData('public/viewreport', param)

    if (res.status == '200') {
      var data = res.data[0]

      if (res.data.length > 0) {

        setReportReasonId(data.reportreasonId)
        setDescription(data.description)
      }
    } else {
      toasterrormsg(res.message)
    }
  }

  // validation function
  const validate = () => {

    var isValid = true;
    var errorTmp = [...error];

    if (reportReasonId == undefined || reportReasonId == null || reportReasonId == "") {
      errorTmp[0].reportReasonId = t('Report Reason Is Required');
      isValid = false;
    }
    if (description == undefined || description == null || description == "") {
      errorTmp[0].description = t('Report Description Is Required');
      isValid = false;
    }
    setError(errorTmp);
    return isValid;
  }
  const saveReportReason = async () => {
    if (validate()) {
      const param = {
        ratingId: selectedRatingId,
        categoryId: categoryId,
        vendorId: vendorId,
        reportreasonId: reportReasonId,
        description: description,
        // reviewReportId: reviewReportId
      }

      var res = await fetchData('public/reviewreport', param)

      if (res.status == '200') {
        setReportReasonId("")
        setSelectedRatingId("")
        handleCloseReportInfo()
        categoryWiseReviewListApiCall()
        toastsuccessmsg(res.message)
      } else {
        toasterrormsg(res.message)
      }
    }
  }


  //   delete hotel api call
  const searchData = async (text: any, isfoc: any) => {
    setSearchTerm(text)
    setFocus(isfoc)

    const escapedTerm = text.replace(/'/g, "''")
    setApiTerm(escapedTerm)
  }

  const handleSort = (column: any, sortDirection: 'asc' | 'desc') => {
    setSortColumn(column.sortField)
    setSortDirection(sortDirection)
  }

  const CustomHeader = (props: any) => {
    const inputRef: any = useRef(null)

    // Define the onchange event handler
    const handleChange = async (e: any) => {
      // Focus on the input element when the onchange event is triggered
      await props.fnserch(e, 1)
      // inputRef.current.focus();
    }
    useEffect(() => {
      // Check if the ref exists and if the component should be focused
      if (inputRef.current && props.isfoc === 1) {
        inputRef.current.focus()
      }
    }, [props.isfoc])

    return (
      <div className='d-flex justify-content-between flex-wrap w-100 my-5'>
        <div className='d-flex align-items-center position-relative my-1 '>
          <KTIcon iconName='magnifier' className='fs-1 position-absolute ms-6' />
          <input
            type='text'
            data-kt-user-table-filter='search'
            className='form-control form-control-solid w-250px ps-14'
            placeholder={t('Search')}
            value={props.search}
            onChange={(e: any) => handleChange(e.target.value)}
            ref={inputRef}
          />
        </div>
      </div>
    )
  }

  const customRating = (rating: any) => {
    return (
      <Rating
        initialValue={rating}
        allowFraction={true}
        readonly
        size={25}
        fillColor='gold'
        emptyColor='gray'
        transition={true}
      />
    )
  }

  // Define your DataTable columns
  const column = useMemo(
    () => [
      {
        name: t('Date Submitted'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.created ? moment(row.created).format('YYYY-MM-DD') : '-'}</div>
          </div>
        ),
        sortField: 'bookingCode',
        sortable: true,
        width: '150px',
      },
      {
        name: t('Customer Name'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.userName || '-'}</div>
          </div>
        ),
        sortable: true,
        width: '200px',
        sortField: 'userName',
      },
      {
        name: categoryId == 1 ? t('Accomodation Name') : categoryId == 4 ? t('Space Name') : categoryId == 5 ? t('Tour Agency Name') : categoryId == 7 ? t('Car Supplier Name') : '',
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.actionName || '-'}</div>
          </div>
        ),
        sortable: true,
        width: '250px',
        sortField: 'actionName',
      },
      {
        name: categoryId == 1 ? t('Property Type') : categoryId == 4 ? t('Space Type') : categoryId == 5 ? t('Tour Type') : categoryId == 7 ? t('Car Type') : '',
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.propertyType || '-'}</div>
          </div>
        ),
        sortable: true,
        width: '250px',
        sortField: 'propertyType',
      },
      {
        name: categoryId == 1 ? t('Room Name') : categoryId == 4 ? t('Rental Space Name') : categoryId == 5 ? t('Tour Name') : categoryId == 7 ? t('Car Name') : '',
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.actionTypeName || '-'}</div>
          </div>
        ),
        sortable: true,
        width: '200px',
        sortField: 'actionTypeName',
      },
      {
        name: t('Rating'),
        cell: (row: any) => (
          <div className='my-3 border-bottom border-primary'>
            <div
              className='fw-bold fs-5 text-primary cursor-pointer'
              onClick={() => {
                setReviewDetail(row)
                handleShowRatingInfo()
              }}
            >
              {parseFloat(row.totalRating).toFixed(1)} {customRating(row.totalRating)}
            </div>
          </div>
        ),
        sortable: true,
        width: '200px',
        sortField: 'totalRating',
      },
      {
        name: t('Verified Booking'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              {"✅"}
            </div>
          </div>
        ),
        sortable: false,
        width: '200px',
      },
      {
        name: t('Report Status'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              {row.reportStatus == "1" ? <> <span className='btn btn-success mx-2 p-1 btn-sm fw-bold w-100px pointer-events-none'>{t('Accepted')}</span> </> : row.reportStatus == "2" ? <> <span className='btn btn-danger mx-2 p-1 btn-sm fw-bold w-100px pointer-events-none'>{t('Rejected')}</span> </> : row.isReported == "0" ? <span className='btn btn-warning mx-2 p-1 btn-sm fw-bold w-100px pointer-events-none'>{t('Not Reported')}</span> : <span className='btn btn-danger mx-2 p-1 btn-sm fw-bold w-100px pointer-events-none'>{t('Reported')}</span>}
            </div>
          </div>
        ),
        sortable: false,
        width: '200px',
      },
      {
        name: t('Action'),
        cell: (row: any) => (
          <div className='my-3'>
            {row.reportStatus == "1" || row.reportStatus == "2" ? "-" : row.isReported == "0" ? <button className='btn btn-sm fs-7' onClick={() => {
              setSelectedRatingId(row.ratingId)
              handleShowReportInfo()
            }}>🛑 {t('Report')}</button> : <button onClick={() => {
              setSelectedRatingId(row.ratingId)
              handleShowReportInfo()
              setReviewIsAlreadySend(true)
            }} className='btn btn-sm fs-7'>⏳ {t('In Review')}</button>}

          </div>
        ),
        sortable: false,
        width: '200px',
      },
    ],
    [t]
  )
  useEffect(() => {
    categoryWiseReviewListApiCall()
    document.title = 'Insayr | View Review Category Wise'
  }, [limit, offset, sortColumn, sortDirection, searchTerm]) // Trigger on pagination changes

  const handlePageChange = (newPage: number) => {
    const totalPages = Math.ceil(totalRecords / limit)
    if (newPage === 1) {
      setOffset(0)
    } else if (newPage === totalPages) {
      setOffset((totalPages - 1) * limit)
    } else {
      setOffset((newPage - 1) * limit)
    }
  }

  const handleRowsPerPageChange = (newRowsPerPage: number, currentPage: number) => {
    setLimit(newRowsPerPage)
  }
  useEffect(() => {
    reportListApiCall()
  }, [lang])

  useEffect(() => {
    if (selectedRatingId) {

      reportDetailApiCall(selectedRatingId)
    }
  }, [selectedRatingId])


  return (
    <>
      <ToastContainer />
      <PageTitle breadcrumbs={[]}>{t('View Reviews & Rating')}</PageTitle>
      <div className="card card-flush py-4">
        <div className="card-body pt-0">
          <DataTable
            columns={column}
            data={reviewList}
            pagination
            paginationServer={true}
            onChangePage={handlePageChange}
            paginationTotalRows={totalRecords}
            paginationPerPage={limit}
            onChangeRowsPerPage={handleRowsPerPageChange}
            paginationRowsPerPageOptions={[5, 10, 15, 20, 25, 30]}
            subHeader={true}
            subHeaderComponent={<CustomHeader search={searchTerm} isfoc={focus} fnserch={searchData} />}
            onSort={handleSort}
            paginationComponentOptions={{
              rowsPerPageText: t('Rows Per Page'),
            }}
            sortServer
          />
        </div>
      </div>
      <Modal show={showRatingInfo} onHide={handleCloseRatingInfo} backdrop='static' keyboard={false}>
        <div
          className='modal fade show'
          id='kt_modal_upload'
          tabIndex={-1}
          style={{ display: 'block' }}
          aria-modal='true'
          role='dialog'
        >
          <div className='modal-dialog modal-dialog-centered mw-700px'>
            <div className='modal-content'>
              <div className='form' id='kt_modal_upload_form'>
                <div className='modal-header d-flex justify-content-between border-bottom border-1 border-success'>
                  <h2 className='fw-bold'>{t('Review Details')}</h2>

                  <div
                    className='btn btn-icon btn-sm btn-active-icon-primary'
                    onClick={handleCloseRatingInfo}
                  >
                    <i className='ki-duotone ki-cross fs-1'>
                      <span className='path1'></span>
                      <span className='path2'></span>
                    </i>
                  </div>
                  {/* <!--end::Close--> */}
                </div>

                <div className='modal-body pt-10 pb-15 px-lg-17'>
                  <h3 className='fw-bold'>{t('Review Text:')}</h3>
                  {reviewDetail?.description ? (
                    <h3 className='fw-semibold mb-5 fs-6'>{reviewDetail?.description}</h3>
                  ) : (
                    <h3 className='fw-semibold mb-5 fs-6'>{t('No Data Found')}</h3>
                  )}
                  <div className="my-10">
                    <h3 className='fw-bold'>{t('Ratings:')}</h3>
                    <table className="table table-row-dashed table-row-gray-300">
                      <tbody>
                        {
                          (categoryId == '1' || categoryId == '4') ? (
                            <>
                              <tr>
                                <td>{t('Cleanliness')}</td>
                                <td>{reviewDetail.cleanliness ? <>{parseFloat(reviewDetail.cleanliness).toFixed(1)} {customRating(reviewDetail.cleanliness)}</> : '-'}</td>
                              </tr>
                              <tr>
                                <td>{t('Staff Service')}</td>
                                <td>{reviewDetail.staffservice ? <>{parseFloat(reviewDetail.staffservice).toFixed(1)} {customRating(reviewDetail.staffservice)}</> : '-'}</td>
                              </tr>
                              <tr>
                                <td>{t('Value for Money')}</td>
                                <td>{reviewDetail.valueForMoney ? <>{parseFloat(reviewDetail.valueForMoney).toFixed(1)} {customRating(reviewDetail.valueForMoney)}</> : '-'}</td>
                              </tr>
                              <tr>
                                <td>{t('Facilities')}</td>
                                <td>{reviewDetail.facilities ? <>{parseFloat(reviewDetail.facilities).toFixed(1)} {customRating(reviewDetail.facilities)}</> : '-'}</td>
                              </tr>
                              <tr>
                                <td>{t('Location')}</td>
                                <td>{reviewDetail.location ? <>{parseFloat(reviewDetail.location).toFixed(1)} {customRating(reviewDetail.location)}</> : '-'}</td>
                              </tr>
                            </>
                          ) : categoryId == '5' ? (
                            <>
                              <tr>
                                <td>{t('Tour Guide')}</td>
                                <td>{reviewDetail.tourGuide ? <>{parseFloat(reviewDetail.tourGuide).toFixed(1)} {customRating(reviewDetail.tourGuide)}</> : '-'}</td>
                              </tr>
                              <tr>
                                <td>{t('Itinerary And Experience')}</td>
                                <td>{reviewDetail.itineraryAndExperience ? <>{parseFloat(reviewDetail.itineraryAndExperience).toFixed(1)} {customRating(reviewDetail.itineraryAndExperience)}</> : '-'}</td>
                              </tr>
                              <tr>
                                <td>{t('Value for Money')}</td>
                                <td>{reviewDetail.valueForMoney ? <>{parseFloat(reviewDetail.valueForMoney).toFixed(1)} {customRating(reviewDetail.valueForMoney)}</> : '-'}</td>
                              </tr>
                              <tr>
                                <td>{t('Transportation And Comfirt')}</td>
                                <td>{reviewDetail.transportationAndComfirt ? <>{parseFloat(reviewDetail.transportationAndComfirt).toFixed(1)} {customRating(reviewDetail.transportationAndComfirt)}</> : '-'}</td>
                              </tr>
                              <tr>
                                <td>{t('Punctuality And Organization')}</td>
                                <td>{reviewDetail.punctualityAndOrganization ? <>{parseFloat(reviewDetail.punctualityAndOrganization).toFixed(1)} {customRating(reviewDetail.punctualityAndOrganization)}</> : '-'}</td>
                              </tr>
                            </>
                          ) : categoryId == '7' ? (
                            <>
                              <tr>
                                <td>{t('Vehicle Condition')}</td>
                                <td>{reviewDetail.vehicleCondition ? <>{parseFloat(reviewDetail.vehicleCondition).toFixed(1)} {customRating(reviewDetail.vehicleCondition)}</> : '-'}</td>
                              </tr>
                              <tr>
                                <td>{t('Pickup & Dropoff Process')}</td>
                                <td>{reviewDetail.pickupDropoffProcess ? <>{parseFloat(reviewDetail.pickupDropoffProcess).toFixed(1)} {customRating(reviewDetail.pickupDropoffProcess)}</> : '-'}</td>
                              </tr>
                              <tr>
                                <td>{t('Value for Money')}</td>
                                <td>{reviewDetail.valueForMoney ? <>{parseFloat(reviewDetail.valueForMoney).toFixed(1)} {customRating(reviewDetail.valueForMoney)}</> : '-'}</td>
                              </tr>
                              <tr>
                                <td>{t('Accuracy Of Listing')}</td>
                                <td>{reviewDetail.accuracyOfListing ? <>{parseFloat(reviewDetail.accuracyOfListing).toFixed(1)} {customRating(reviewDetail.accuracyOfListing)}</> : '-'}</td>
                              </tr>
                              <tr>
                                <td>{t('Vendor Communication')}</td>
                                <td>{reviewDetail.vendorCommunication ? <>{parseFloat(reviewDetail.vendorCommunication).toFixed(1)} {customRating(reviewDetail.vendorCommunication)}</> : '-'}</td>
                              </tr>
                            </>
                          ) : (<></>)
                        }
                        <tr>
                          <td className='fw-bold fs-5'>{t('TOTAL')}</td>
                          <td>{reviewDetail.totalRating ? <>{parseFloat(reviewDetail.totalRating).toFixed(1)} {customRating(reviewDetail.totalRating)}</> : '-'}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div className='row mt-5'>
                    <h2>{t('Photos')}:</h2>
                    {reviewDetail?.media
                      ? reviewDetail?.media.map((imageList: any, index: any) => (
                        <>
                          <div className='col-lg-2 col-4 d-flex flex-column mb-5' key={index}>
                            <div
                              style={{ maxWidth: 'fit-content' }}
                              className='p-2 shadow rounded-1'
                            >
                              <img
                                alt='images'
                                src={url + imageList.image}
                                width='100%'
                                className='rounded-1'
                              />
                            </div>
                          </div>
                        </>
                      ))
                      : ''}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
      <Modal show={showReportInfo} onHide={handleCloseReportInfo} backdrop='static' keyboard={false}>
        <div
          className='modal fade show'
          id='kt_modal_upload'
          tabIndex={-1}
          style={{ display: 'block' }}
          aria-modal='true'
          role='dialog'
        >
          <div className='modal-dialog modal-dialog-centered mw-700px'>
            <div className='modal-content'>
              <div className='form' id='kt_modal_upload_form'>
                <div className='modal-header d-flex justify-content-between border-bottom border-1 border-success'>
                  <h2 className='fw-bold'>{t('Report Review')}</h2>

                  <div
                    className='btn btn-icon btn-sm btn-active-icon-primary'
                    onClick={handleCloseReportInfo}
                  >
                    <i className='ki-duotone ki-cross fs-1'>
                      <span className='path1'></span>
                      <span className='path2'></span>
                    </i>
                  </div>
                  {/* <!--end::Close--> */}
                </div>

                <div className='modal-body pt-10 pb-5 '>
                  <div className='row'>
                    <div className="col-lg-12">
                      <label className="required fs-4 form-label required">{t('Report Reason')}</label>
                      <Select
                        name='reportReasonId'
                        id='reportReasonId'
                        placeholder={t('Select Report Reason')}
                        isSearchable={true}
                        isClearable={true}
                        isDisabled={reviewIsAlreadySend}
                        options={reportReasonList}
                        value={reportReasonList.find(
                          (option: any) => option.value == reportReasonId
                        ) || ""}
                        onChange={(e: any) => { setReportReasonId(e ? e.value : ''); removeError('reportReasonId') }}
                      />
                      <div className='text-danger fw-bold'>{error[0].reportReasonId}</div>
                    </div>
                    <div className="col-lg-12">
                      <label className="required fs-4 form-label required">{t('Report Description')}</label>
                      <textarea
                        name='description'
                        className="form-control mb-2"
                        placeholder={t('Write the details of your report')}
                        disabled={reviewIsAlreadySend}
                        value={description}
                        onChange={(e: any) => { setDescription(e ? e.target.value : ''); removeError('description') }}
                      ></textarea>
                      <div className='text-danger fw-bold'>{error[0].description}</div>
                    </div>
                  </div>
                  {
                    !reviewIsAlreadySend && (
                      <div className="d-flex justify-content-center mt-6">
                        <div onClick={handleCloseReportInfo} id="kt_ecommerce_add_product_cancel" className="btn btn-light me-5">{t('Cancel')}</div>
                        <button type="submit" className="btn btn-primary" onClick={() => { saveReportReason() }}>
                          <span className="indicator-label">{t('Submit')}</span>
                          {loading && (
                            <span className="spinner-border spinner-border-sm mx-2" role="status" aria-hidden="true"></span>
                          )}
                        </button>
                      </div>
                    )
                  }
                </div>

              </div>

            </div>

          </div>
        </div>
      </Modal>
    </>
  )
}

export { ViewRatingAndReviewBookingWise }
